import React from 'react';
import { BrainIcon, ZapIcon, DatabaseIcon, WrenchIcon, CircleIcon } from 'lucide-react';

/**
 * Returns appropriate icon for span based on operation type
 */
export const getSpanIcon = (spanName: string, operationName?: string) => {
  const iconProps = {
    className: 'size-3.5 text-neutral-600',
    strokeWidth: 2.5
  };

  const identifier = (spanName || operationName || '').toLowerCase();

  // Agent invocation
  if (identifier.includes('invoke_agent') || identifier.includes('agent')) {
    return <BrainIcon {...iconProps} />;
  }

  // LLM inference
  if (identifier.includes('inference') || identifier.includes('llm')) {
    return <ZapIcon {...iconProps} />;
  }

  // Knowledge retrieval
  if (identifier.includes('retrieve') || identifier.includes('knowledge')) {
    return <DatabaseIcon {...iconProps} />;
  }

  // Tool execution
  if (identifier.includes('tool') || identifier.includes('execution')) {
    return <WrenchIcon {...iconProps} />;
  }

  // Default
  return <CircleIcon {...iconProps} />;
};
